import { debounce, isElement, forEach } from 'lodash';
import mustache from 'mustache';

import { get as getPageOptions } from '../../01-helpers/utilities/options';
import { stringToNode } from '../../01-helpers/utilities/node';

/**
 * this module with update the price of a product
 * 
 * 1) handle onchange
 * 2) get price/memberprice
 * 3) update price/memberprice
 * 
 **/

const moduleName = 'variant',
    selectors = {
        base: `.js-${moduleName}`,
        trigger: `.js-${moduleName}-trigger`,
        priceContainer: `.js-${moduleName}-price-container`,
        price: `.js-${moduleName}-price`,
        memberprice: `.js-${moduleName}-memberprice`,
        description: `.js-${moduleName}-description`,
        amount : `.js-${moduleName}-amount`,
        submit: `.js-${moduleName}-submit`
    },
    template = {
        memberPrice: `
            <div class="c-price c-price--members">
                <span class="js-variant-memberprice"></span> {{ MemberPrice }}
            </div>`
    },
    translationsKey = {
        key: 'translations',
        memberprice: 'MemberPrice',
        instock: 'InStock',
        outofstock: 'OutOfStock'
    },
    priceFormat = new Intl.NumberFormat('nl-NL',
        {
            minimumFractionDigits: 2
        }
    );

export default class Variant {
    constructor(baseElement) {
        if (!isElement(baseElement)) {
            return false;
        }

        this._configure(baseElement);
        this._setup();
    }

    getPriceAsFloat(price) {
        const convertedPrice = price.replace(',', '.'),
            priceAsFloat = Number.parseFloat(convertedPrice);

        return priceAsFloat;
    }


    _setNewPrice(element, price, member = false) {
        if (!isElement(element)) {
            return false;
        }

        price = this.getPriceAsFloat(price);

        if (member && price <= 0) {
            element.remove();
            this.memberPriceElement = null;
        } else {
            element.innerHTML = priceFormat.format(price);
        }
        
    }

    _toggleOutOfStock(disable = false) {
        if (disable) {
            this.submitElement.setAttribute('disabled', true);
            this.submitElement.innerHTML = this.translations[translationsKey.outofstock];
            this.amount.setAttribute('disabled', true);
        }
        else {
            this.submitElement.removeAttribute('disabled');
            this.submitElement.innerHTML = this.translations[translationsKey.instock];
            this.amount.removeAttribute('disabled');
        }
    }

    //========= Event Handling ==========//

    _onChangeHandler(ev) {
        this.baseElement.classList.add('is-loading');
        // get the selected option
        const element = ev.currentTarget || ev.target,
            option = element.selectedOptions[0],
            dataset = option.dataset,
            // get the memberprice
            memberPrice = dataset.shopMemberprice,
            // get the price
            price = dataset.shopPrice,
            description = dataset.shopDescription,
            outOfStock = dataset.shopOutofstock == 'True';

        this._setNewPrice(this.priceElement, price);

        // if this.memberPriceElement is not an element, we create one.
        if (!isElement(this.memberPriceElement) && this.getPriceAsFloat(memberPrice) > 0) {
            this.memberPriceElement = stringToNode(mustache.render(template.memberPrice,
                {
                    MemberPrice: this.translations[translationsKey.memberprice]
                }
            ));
            this.priceContainer.insertBefore(this.memberPriceElement, this.priceElement);
        }
        this._setNewPrice(this.memberPriceElement, memberPrice, true);

        this.descriptionElement.innerHTML = description;

        this._toggleOutOfStock(outOfStock);

        // updated the price/memberprice
        setTimeout(() => {
            this.baseElement.classList.remove('is-loading');
        }, 500);
        
    }

    _bindEvents() {
        forEach(this.triggers, (trigger) => {
            trigger.addEventListener('change', (event) => this._onChangeHandler(event));
        });
    }

    //===================================//

    //========= Initialization ==========//

    _configure(baseElement) {
        this.baseElement = baseElement;
        this.triggers = this.baseElement.querySelectorAll(selectors.trigger);
        this.priceContainer = this.baseElement.querySelector(selectors.priceContainer);
        this.priceElement = this.priceContainer.querySelector(selectors.price);
        this.memberPriceElement = this.priceContainer.querySelector(selectors.memberprice);
        this.descriptionElement = this.baseElement.querySelector(selectors.description);
        this.amount = this.baseElement.querySelector(selectors.amount);
        this.submitElement = this.baseElement.querySelector(selectors.submit);
    }

    _setup() {
        this.translations = getPageOptions(translationsKey.key);
        this._bindEvents();
    }

    //===================================//
}

const initVariant = () => {
    forEach(document.querySelectorAll(selectors.base), (baseElement) => {
        new Variant(baseElement);
    });
};

initVariant();